import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: white;
  padding: 32px;
  border-radius: 10px;
  width: 830px;
  max-width: calc(100vw - 32px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 5px 16px;
`;

export const HeaderContent = styled.div`
  flex: 1;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  
  &:hover {
    color: ${({ theme }) => theme.tokens.color.text.primary};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.tokens.color.interaction.softDefault};
    outline-offset: 2px;
    border-radius: 4px;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ModalBody = styled.div<{ $hasIcon?: boolean }>`
  padding: 16px;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  line-height: 1.5;
`;

export const HighlightText = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.tokens.color.text.primary};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px;
`;
